// export const baseURL = "http://192.168.1.154:5001/v1/";
// export const rootURL = "http://192.168.1.154:5001";
export const baseUrlGateway = "https://app.medicmms.vn/v1/";
export const baseExportURL = "https://app.medicmms.vn/api";
// export const baseUrlGateway = "http://192.168.1.154:5000/v1/";
export const baseURL = "https://app.medicmms.vn";
export const rootURL = "https://api.medicmms.vn";
export const urlAssetMaintenance =  "https://m.medicmms.vn/scan-QR-code-home?assetMaintenance=";
